// extracted by mini-css-extract-plugin
export var container = "_ek-0";
export var content = "_ek-3";
export var customerTitle = "_ek-4";
export var empty = "_ek-5";
export var gray = "_ek-6";
export var header = "_ek-7";
export var info = "_ek-8";
export var loading = "_ek-2";
export var loadingCard = "_ek-9";
export var oneLine = "_ek-a";
export var personName = "_ek-e";
export var pillContainer = "_ek-b";
export var selected = "_ek-1";
export var text = "_ek-c";
export var twoLines = "_ek-d";
export var unread = "_ek-f";
export var unreadIndicator = "_ek-g";